import Request from ".";
export const getLeaveTypes = async (all = false) => {
  const url = all ? "getallleavetypes" : "getleavetypes";
  const result = await Request.post(url, {}, { headers: { Accept: "application/json, */*", "Content-Type": "application/json" } });
  return result.data;
};
export const insertLeaveType = async (data) => {
  const result = await Request.post("insertleavetype", data, { headers: { Accept: "application/json, */*", "Content-Type": "application/json" } });
  return result.data;
};
export const updateLeaveType = async (data) => {
  const result = await Request.post("updateleavetype", data, { headers: { Accept: "application/json, */*", "Content-Type": "application/json" } });
  return result.data;
};
export const deactivateLeaveType = async (data) => {
  const result = await Request.post("deactivateleavetype", data, { headers: { Accept: "application/json, */*", "Content-Type": "application/json" } });
  return result.data;
};
